module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs web-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/conversions/conversion',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-tachometer"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.conversion')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/conversions/new_orders',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.new_orders')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/conversions/new_orders_week',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.new_orders_week')))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57054616"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/operators/conversions/OperatorsConversionTabs.vue
// module id = 559
// module chunks = 0